import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductStart } from '@bca-user-data/models/_enums';
import { environment } from '@environments/environment';
import moment from 'moment';

@Component({
  selector: 'bca-use-product',
  templateUrl: 'use-product.component.html',
  styleUrls: ['use-product.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UseProductComponent implements OnInit {
  @Input()
  selectedProductUsage: ProductStart;
  @Input()
  selectedProductUsageDate: Date;
  @Input()
  useProduct: {
    value: ProductStart;
    displayText: string;
    displayTextOptional?: string;
  }[] = [
    {
      value: ProductStart.DIRECTLY,
      displayText: 'USER_DATA.INPUT.DIRECTLY',
      displayTextOptional: 'USER_DATA.INPUT.DIRECTLY_OPTIONAL'
    },
    {
      value: ProductStart.DATE,
      displayText: 'USER_DATA.INPUT.ON_DATE'
    }
  ];

  @Output()
  selected = new EventEmitter<ProductStart>();
  @Output()
  dateSelected = new EventEmitter<Date>();
  formattedDate: string;

  ngOnInit(): void {
    this.formatDate();
  }

  minimalUseDate = moment()
    .add(environment.userData.useProductMinDays, 'days')
    .toDate();

  maximalUseDate = moment()
    .add(environment.userData.useProductMaxDays, 'days')
    .toDate();

  ProductStart = ProductStart;
  constructor(private datePipe: DatePipe) {}


  formatDate() {
    const dateToFormat = this.selectedProductUsageDate || this.minimalUseDate;
    this.formattedDate = this.datePipe.transform(dateToFormat, 'dd-MM-YYYY');
  }
}
